import { Grid, Typography } from "@mui/material"
import { memo } from "react"
import { TVisualizarItemProps } from "./financas.model"

const VisualizarItem = (props: TVisualizarItemProps) => {
    return (
        <Grid item sx={{
            width: '100%',
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-evenly",
            marginBottom: "5px",
            paddingLeft: "15px",
            marginTop: props.marginTop,
            marginLeft: props.marginLeft
        }}>
            <Typography sx={{
                width: "20%",
                textAlign: "justify",
                fontWeight: props.noFontweight ? undefined : "bold",
                fontSize: "16px"
            }}>
                {props.title}
            </Typography>

            <Typography sx={{
                width: "80%",
                paddingLeft: "15px",
                fontSize: "16px"
            }}>
                {props.item}
            </Typography>
        </Grid>
    )
}

export default memo(VisualizarItem)
